import React, { useEffect, useState } from 'react'
import Carousel from 'react-bootstrap/Carousel'
import Header from '../../components/HeaderNoMenu'
import api from '../../_services/api'
import { useParams } from 'react-router-dom'
import Button from '../../components/Button'
import { useCart } from '../../hooks/CartContext'
import PropTypes from 'prop-types'
import {
  Container, ContainerProduct, Banner,
  Content, Title, Description, Spots,
  Details, CuttingStitches, SoldBy,
  DivVariant, Cashback, Space
} from './styles'

export default function ProductItem() {
  const [data, setData] = useState([])
  const [Loading, setLoading] = useState(true)
  const { id } = useParams()
  const { putProductInCart } = useCart()



  return (


    <>
      <Header />
      <Container>
        <ContainerProduct>
          <Banner>
            <Carousel variant="dark">

              <Carousel.Item className="test">
                <img
                  className="d-block w-100"
                  src="https://th.bing.com/th/id/R.7faf39390f84cdba85b6c1870dfbd548?rik=Xb%2bGucFSx%2bMvrQ&pid=ImgRaw&r=0"
                /* alt={data.label} */
                />
              </Carousel.Item>
            </Carousel>
          </Banner>
          <Content>
            <div>              
              <Title>label</Title>
              <Details>short_description</Details>
              <CuttingStitches>price.BRL.finalPts</CuttingStitches>
              <Spots>price.C6.final<span>Pts</span> </Spots>
              <Details>Detalhes</Details>
              <Description>
                description
              </Description>
              <SoldBy>Vendido por: <span>seller.label</span></SoldBy>
              <DivVariant>
                <div className="ContainerSelect">
                  <label>Label</label>
                  <select>
                    <option value="">Selecione</option>
                    <option value="">Selecione</option>
                  </select>
                </div>

                <div className="ContainerSelect">
                  <label>Label</label>
                  <select>
                    <option value="">Selecione</option>
                  </select>
                </div>
              </DivVariant>
              <Button>Adicionar na sacola</Button>
            </div>
          </Content>
        </ContainerProduct>
        <Space />
      </Container >
    </>
  )
}

ProductItem.propTypes = {
  product: PropTypes.object
}
